import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getAvailableLocales, getLocale } from '../selectors';
import { changeLocale } from '../actions';
import Header from '../views/header';

const mapDispatchToProps = {
  changeLocale,
};

const mapStateToProps = createStructuredSelector({
  availableLocales: getAvailableLocales,
  locale: getLocale,
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/containers/header.js